import React from 'react';
import styled from 'styled-components';
import { Select } from 'antd';

import CONVERSION_OVER_TIME from '../../../../../constants/funnels';

const { Option } = Select;

const StyledConversionMenuContainer = styled.div`
  display: flex;
  padding: 0 20px;

  .select-container {
    margin: 5px;
  }
`;

const StyledSelect = styled(Select)`
  width: auto;
  flex-shrink: 0;
  min-width: 150px;
`;

const ConversionMenu = ({ interval, onChangeInterval }) => (
  <StyledConversionMenuContainer>
    <div className="select-container">
      Conversion over time:
      <StyledSelect
        showSearch
        optionFilterProp="children"
        filterOption={(input, option) =>
          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        dropdownMatchSelectWidth={false}
        dropdownStyle={{ width: 'auto' }}
        value={interval}
        onSelect={onChangeInterval}
        className="ant-select-border-bottom"
        getPopupContainer={(triggerNode) => triggerNode}
        virtual={false}
      >
        {CONVERSION_OVER_TIME.map((e) => (
          <Option key={e.value} value={e.value}>
            {e.view}
          </Option>
        ))}
      </StyledSelect>
    </div>
  </StyledConversionMenuContainer>
);

export default ConversionMenu;
